import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import { useBCApi } from './hooks/BCApi';
import { receive } from '../../Actions/Cart.action';
import { useDispatch } from 'react-redux';

export const BCOrderHistoryRowNonBC = ({ order }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButtonMessage, setShowButtonMessage] = useState('');
  const dispatch = useDispatch();

  const { status, value, error, execute } = useBCApi(
    '/api/bcmypages/orders',
    false
  );

  useEffect(() => {
    let timer;
    if (status === 'success') {
      dispatch(receive(value));
      setShowButtonMessage('success');
      timer = setTimeout(() => {
        setShowButtonMessage('');
      }, 1500);
    }
    if (status === 'error') {
      setShowButtonMessage('error');
      timer = setTimeout(() => {
        setShowButtonMessage('');
      }, 1500);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, status, value]);

  return (
    <div>
      <div className="OrdersTab__content__orderhistory-table__body__row">
        <p>{order.orderNumber}</p>
        <p>{order.orderDate}</p>
        <p>{order.totalAmountExcludingTax}</p>
        <p>
          {order.shipToContact && order.shipToContact.length > 0
            ? order.shipToContact
            : order.contactPerson && order.contactPerson.length > 0
            ? order.contactPerson
            : translate('business.orderstab.orderhistory.notspecified')}
        </p>
        <i
          className={`OrdersTab__icon OrdersTab__icon__${
            !order.isWaitingApprove ? 'approved' : 'pending'
          }`}
        />
        <p>{order.status}</p>
        <div className="OrdersTab__content__orderhistory-table__body__row__icons-container">
          <div className="OrdersTab__icon__group">
            <div className="OrdersTab__icon OrdersTab__icon__cart-button">
              {showButtonMessage === 'success' ? (
                <div>&#10003;</div>
              ) : showButtonMessage === 'error' ? (
                <div>&#10007;</div>
              ) : (
                <i
                  className="OrdersTab__icon__cart-button__icon"
                  onClick={() => {
                    execute('POST', { orderId: order.orderId });
                  }}
                />
              )}
            </div>
          </div>
          <div className="OrdersTab__content__orderhistory-table__body__row__icons-container__separator" />
          <i
            className={`OrdersTab__icon OrdersTab__icon__chevron-down${
              isExpanded ? '__open' : ''
            }`}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
      </div>
      <div>
        <div
          className={`OrdersTab__content__orderhistory-table__body__row__dropdown
                        OrdersTab__content__orderhistory-table__body__row__dropdown${
                          isExpanded ? '__active' : '__inactive'
                        }`}
        >
          <div className="OrdersTab__content__orderhistory-table__body__row__dropdown__header">
            <p>{translate('business.orderstab.orderhistory.deliverydate')}</p>
            <p>
              {translate('business.orderstab.orderhistory.deliveryaddress')}
            </p>
            <p>{translate('business.orderstab.orderhistory.reference')}</p>
            <p></p>
            <p></p>
          </div>
          <div className="OrdersTab__content__orderhistory-table__body__row__dropdown__row">
            <p>{order.orderDate ? order.orderDate : 'Missing Date'}</p>
            <p>
              {order.shipToAddressLine1}
              <br />
              {order.shipToPostCode &&
                order.shipToCity &&
                [order.shipToPostCode, order.shipToCity]
                  .filter((x) => x.length > 0)
                  .join(', ')}
              <br />
              {order.shipToState &&
                order.shipToCountry &&
                [order.shipToState, order.shipToCountry]
                  .filter((x) => x.length > 0)
                  .join(', ')}
            </p>
            <p>
              {order.externalDocumentNumber ??
                translate('business.orderstab.orderhistory.noreference')}
            </p>
            <p>{order.deliveryMethod}</p>
          </div>
          <p className="OrdersTab__content__orderhistory-table__body__row__dropdown__order-rows-title">
            {translate('business.orderstab.orderhistory.orderrows')}
          </p>
          <hr></hr>
          <div className="OrdersTab__content__orderhistory-table__body__row__dropdown__header__products">
            <p>{translate('business.orderstab.orderhistory.product')}</p>
            <p>{translate('business.orderstab.orderhistory.amount')}</p>
            <p>{translate('business.orderstab.orderhistory.productprice')}</p>
          </div>
          {order.salesOrderLines.map((orderRow, index) => (
            <div
              key={index}
              className="OrdersTab__content__orderhistory-table__body__row__dropdown__row__products"
            >
              <p>{orderRow.description}</p>
              <p>{orderRow.quantity}</p>
              <p>{orderRow.unitPrice}</p>
            </div>
          ))}
          {order.totalTaxAmount && (
            <p className="OrdersTab__content__orderhistory-table__body__row__dropdown__total">
              {translate('business.orderstab.orderhistory.totalvat')}:{' '}
              {order.totalTaxAmount}
            </p>
          )}

          <p className="OrdersTab__content__orderhistory-table__body__row__dropdown__total">
            {translate('business.orderstab.orderhistory.grandtotal')}:{' '}
            {order.totalAmountIncludingTax}
          </p>
        </div>
      </div>
    </div>
  );
};
